























import Card from '@/components/Card.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Card
  }
})
export default class ImageUploadProgress extends Vue {
  @Prop(Number) groupId!: number;
  @Prop() items!: Map<string, number>;
  @Prop() images!: File[];

  public isSuccess: boolean = false;
  public isFailed: boolean = false;

  get progressItems() {
    return this.items;
  }

  getImage(imageName: string) {
    console.log(`'imageName': ${imageName}`);
    this.images.find((image) => image.name === imageName);
  }

  closeProgressBar() {
    this.$emit('toggleProgressBar', false);
  }
}
